import { gql } from "@outschool/ui-apollo";
import { ListingCardFragment } from "@outschool/ui-components-website";

export const contentfulMagnetPageFragment = gql`
  ${ListingCardFragment}

  fragment contentfulMagnetPageFragmentCSR on ContentfulMagnetPage {
    categoryLabel {
      value
    }
    title
    magnetPageSlug
    author {
      uid
      name
      description
      isTeacher
      profileImage {
        url
      }
    }
    summary {
      json
    }
    headerImage {
      url(transform: { quality: 70, width: 692, height: 302, format: WEBP })
    }
    upsellClassCarousel {
      title
      listings(limit: 10) {
        listings {
          ...ListingCard_listing
        }
      }
    }
    body {
      json
      links {
        assets {
          block {
            sys {
              id
            }
            url(
              transform: { quality: 70, width: 692, height: 302, format: WEBP }
            )
            title
            width
            height
            description
          }
        }
      }
    }
    category {
      nameTitleCased
      slug
      related {
        nameTitleCased
        slug
      }
      siblings {
        nameTitleCased
        slug
      }
      children {
        nameTitleCased
        slug
      }
    }
    relatedMagnetPages(limit: 10) {
      items {
        magnetPageSlug
        path
        gradeNameSlug
        categoryLabel {
          value
        }
        title
        author {
          name
          profileImage {
            url
          }
        }
        headerImage {
          url(transform: { quality: 70, width: 692, height: 302, format: WEBP })
        }
      }
    }
  }
`;
